module.exports = __webpack_public_path__ + "static/media/directory.6938725e.svg";